module.exports = __webpack_public_path__ + "static/media/bh.ed58b9b4.webp";